var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated-svg-illustration",domProps:{"innerHTML":_vm._s(_vm.svgMarkup)}})
}
var staticRenderFns = []

export { render, staticRenderFns }